import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { jsx } from 'react/jsx-runtime';

var Tabs = React.forwardRef(function Tabs2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(TabsPrimitive.Root, { ref, className: cn("min-w-0 max-w-full", className), ...props });
});
var TabsList = React.forwardRef(function TabsList2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.List,
    {
      ref,
      className: cn(
        // Never wider than its container: five tabs on the seed page measured
        // 640px in a 492px card and scrolled the WHOLE page sideways, the last
        // tab off-screen (2026-10-01). The strip scrolls itself instead —
        // `justify-start`, since a centred overflow clips its first tab
        // where no scrollbar can reach; a strip that fits shrink-wraps anyway.
        "inline-flex h-9 max-w-full items-center justify-start overflow-x-auto rounded-lg bg-muted p-1 text-muted-foreground",
        className
      ),
      ...props
    }
  );
});
var TabsTrigger = React.forwardRef(function TabsTrigger2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.Trigger,
    {
      ref,
      className: cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm focus-ring",
        className
      ),
      ...props
    }
  );
});
var TabsContent = React.forwardRef(function TabsContent2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    TabsPrimitive.Content,
    {
      ref,
      className: cn("mt-2 min-w-0 max-w-full ring-offset-background focus-visible:outline-hidden", className),
      ...props
    }
  );
});
var NativeSelect = React.forwardRef(
  function NativeSelect2({ className, density = "default", ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "select",
      {
        ref,
        className: cn(
          "flex w-full min-w-0 max-w-full rounded-md border border-input bg-background px-2 py-1 text-foreground ring-offset-background",
          "focus-ring",
          "disabled:cursor-not-allowed disabled:opacity-50",
          density === "sm" ? "h-8 text-xs" : "h-9 text-sm",
          className
        ),
        ...props
      }
    );
  }
);

export { NativeSelect, Tabs, TabsContent, TabsList, TabsTrigger };
//# sourceMappingURL=chunk-XGR2NXWI.js.map
//# sourceMappingURL=chunk-XGR2NXWI.js.map